export const MEALPLANNER_PATH = '/ecom/recipes/meal-plans';
